import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
const LoadingSkeleton = () => {
  return (
    <Skeleton animation="wave" variant="rect" width='80%' height={200} style={{ margin: '20px 0px' }} />
  )
}

export default LoadingSkeleton
